import axios from "axios";
import { isEmpty } from "lodash";
import { getSweetAlert } from "../helper";
let csrfTokenCache = null;

let pendingRequests = 0;
const setLoading = (active) => {
  window.dispatchEvent(new CustomEvent("api-loading", { detail: { active } }));
};
// Function to fetch CSRF token from the backend
const fetchCsrfToken = async () => {
  // const response = await axios.get(`${process.env.REACT_APP_API_URL}/csrf-token`, {
  //   withCredentials: true, // Allows cookies to be sent with the request
  // });
  // return response.data.csrfToken;
  
  if (csrfTokenCache) return csrfTokenCache;
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/csrf-token`, {
    withCredentials: true,
  });
  csrfTokenCache = response.data.csrfToken;
  return csrfTokenCache;
};

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Sends cookies with each request
});

apiClient.interceptors.request.use(async (config) => {
  pendingRequests++;
  if (pendingRequests === 1) setLoading(true);
  try {
    let tokens = '';
    const getItem = localStorage.getItem('persist:prediction');
    if (getItem) {
      const parsed = JSON.parse(getItem);
      const loginSlice = parsed?.loginSlice && JSON.parse(parsed.loginSlice);
      tokens = loginSlice?.token || '';
    }
    if (tokens.length > 1500) {
      console.warn("Token length too large:", tokens.length);
    }
    config.headers["auth_token"] = tokens;
    config.headers["token"] = tokens;
    // Cached CSRF fetch
    const csrfToken = await fetchCsrfToken();
    config.headers["csrf-token"] = csrfToken;

    if (JSON.stringify(config.headers).length > 8000) {
      console.error("Request headers too large. Aborting.");
      throw new Error("Request header fields too large");
    }

    return config;
  } catch (err) {
    console.error("Error in request interceptor:", err);
    throw err;
  }
});


apiClient.interceptors.response.use(function (response) {
  pendingRequests = Math.max(0, pendingRequests - 1);
  if (pendingRequests === 0) setLoading(false);
  return response;
}, async function (error) {
  pendingRequests = Math.max(0, pendingRequests - 1);
  if (pendingRequests === 0) setLoading(false);
  // Network / no-response errors (offline, server down, CORS)
  if (!error.response) {
    getSweetAlert('error', 'Network error — unable to reach the server. Please check your connection.')
    return Promise.reject(error)
  }

  const msg = error.response.data?.error || error.response.data?.message

  if (msg === "Session expired. Please log in again.") {
    localStorage.removeItem("persist:prediction");
    window.location.href = "/login";
    return Promise.reject(error);
  }

  // Let login page handle its own credential errors
  if (msg === "User does not exists" || msg === 'Wrong credentials') {
    return Promise.reject(error);
  }

  getSweetAlert('error', msg || `Server error (${error.response.status})`)
  return Promise.reject(error)
});
export default apiClient;
